export default "__VITE_ASSET__CnBMzXEC__"